import React, { Component, useEffect, useState } from 'react';
import images from '../../../data/images_data_20250320.json'
import * as d3 from "d3";

function Overview (props) {

    const color = {
        gray: 'rgb(200,200,200)',
        darkgray: 'rgb(200,200,200)',
        white: 'rgb(25,25,25)',
        highlight: 'rgb(15,15,15)'
    }

    function capitalize (string) {
        if (string) return string.charAt(0).toUpperCase() + string.slice(1);
        else return '–'
    }

    useEffect(() => {
        d3.select('#evaluation').style('height', 'auto')
        d3.select('#images').selectAll('.unit').data(images).join(
            function(enter){
                const unit = enter.append('div')
                    .attr('class', 'unit')
                    .style('background-color', d => d.correct ? color.white : color.highlight)

                unit.append('div')
                    .attr('class', 'unit_image')
                    .style('background-image', d => 'url("./img/portraits_20250320/'+ d.file+'")')
                
                const description = unit.append('div')
                    .style('padding', '3px')
                    .style('display', 'flex')
                    .style('flex-wrap', 'wrap')
                    .style('align-content', 'space-between')
                    .style('min-height', '95px')
                
                description.append('h5').style('color', color.darkgray).html(d => capitalize(d.prompt))

                const small = description.append('div').style('width', '100%')

                small.append('h6').attr('class', 'smallText').style('opacity', 0.3).html(d => d.model)
                small.append('h6').attr('class', 'smallText').style('opacity', 0.3).html(d => d.date)

                unit.on('mouseenter', function(){
                    d3.selectAll('.unit_image').transition().style('filter', 'invert()')
                    d3.select(this).transition().duration(1000).ease(d3.easeCubicInOut)
                        .style('width', '150px')
                        .style('height', '250px')
                        
                    d3.select(this).select('.unit_image').transition().duration(1500).ease(d3.easeCubicInOut)
                        .style('height', '230px')
                        .style('filter', undefined)

                })
                .on('mouseleave', function(){
                    d3.selectAll('.unit_image').transition().style('filter', undefined)
                    d3.select(this).transition().duration(1500).ease(d3.easeCubicInOut)
                        .style('width', '100px')
                        .style('height', '200px')

                    d3.select(this).select('.unit_image').transition().duration(500).ease(d3.easeCubicInOut)
                        .style('height', '100px')
                })
            }
        )
    })

    return (
        <div>          
        <div id="images" >
            
        </div>
        </div>
    )
}

export default Overview;